import React from 'react'
import '../styles/transaction.css'
import Detailtransaction from '../components/Detailtransaction'


function Transaction() {
    return (
            <Detailtransaction />
    )
}


export default Transaction